import type { CheerioAPI } from 'cheerio';

import { parseIndexAttr } from '../doc-engine/text';
import { computeStableCitationIndices } from '../tiptap/nodes/literatureCitation/plugins/getAutoIndexLiteratureCitationsPlugin';

/** Doc-order occurrences drive the same first-appearance tie-break the editor's auto-index plugin uses. */
export const collectLiteratureCitationIndices = ($: CheerioAPI): Map<string, number> => {
  const occurrences: { literatureId: string | null; currentIndex: number | null }[] = [];
  $('literature-citation').each((_, el) => {
    const $el = $(el);
    occurrences.push({
      literatureId: $el.attr('data-literature-id') || null,
      currentIndex: parseIndexAttr($el.attr('data-index')),
    });
  });
  const wanted = computeStableCitationIndices(occurrences);
  const byId = new Map<string, number>();
  occurrences.forEach((occ, i) => {
    if (occ.literatureId && wanted[i] != null) byId.set(occ.literatureId, wanted[i]);
  });
  return byId;
};
